var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9944 22H3.8783C3.07764 22 2.60165 21.106 3.04866 20.4417L5.48827 16.8165L5.76369 16.4072M10.9944 22L14.5804 10M10.9944 22H16.1427H21.0056M14.5804 10H10.6078C10.275 10 9.96399 10.1656 9.77818 10.4417L8.61126 12.1757L8.39304 12.5M14.5804 10C14.5804 10 15.5326 10 16.1427 10C16.8269 10 17.5017 10 17.5017 10M21.0056 22H28.1324C28.9309 22 29.4073 21.1102 28.9646 20.4456L26.2746 16.4072M21.0056 22L17.5017 10M17.5017 10H21.4713C21.8058 10 22.1181 10.1672 22.3035 10.4456L23.672 12.5M6.27207 15.6517L6.03771 16L5.76369 16.4072M6.27207 15.6517L5.76369 16.4072M6.27207 15.6517L8.39304 12.5M26.2746 16.4072L25.7714 15.6517L23.672 12.5M26.2746 16.4072H5.76369M8.39304 12.5H23.672",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorIcon);
export default __webpack_public_path__ + "static/media/floor-icon.67e5ebb93cd2afcef32f3ebb881875c2.svg";
export { ForwardRef as ReactComponent };